import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { ChatDetail, ChatWrite } from 'types/api'
import type { BaseParams } from 'types/utils'

export function useUpdateChat() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  async function updateChat({
    id,
    body
  }: BaseParams<[ChatWrite, ChatDetail], 'PUT'>) {
    if (!id) throw new Error('Chat ID is required')
    const res = await apiClient.put<ChatDetail>(
      `${SNA_PREFIX}chats/${id}/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateChat,
    onSuccess: (data, variables) => {
      variables.params?.onSuccess?.(data)
      toast.success({ message: t('chatUpdated') })
      queryClient.invalidateQueries({ queryKey: ['chats'] })
    },
    onError: (data, variables) => {
      variables?.params?.onError?.()
      onError(data)
    } // Updated to use useOnError
  })
}
